<router-outlet></router-outlet>
<p-confirmDialog
    header="Xác nhận"
    acceptLabel="Có"
    rejectLabel="Không"
    icon="pi pi-exclamation-triangle"
></p-confirmDialog>
<p-toast></p-toast>
